import { BaseTextMergeElement } from "./Elements/BaseTextMergeElement";

export class ExpressionTextElementData {
    name: string;
    type: string;
    example: BaseTextMergeElement;

    constructor(example: BaseTextMergeElement, type: string, name: string) {
        this.example = example;
        this.name = name;
        this.type = type;
    }

    create(): BaseTextMergeElement {
        let prototype = Object.getPrototypeOf(this.example);
        return new prototype.constructor();
    }
}

export class TextElementRegistration {
    static registrations: { [key: string]: ExpressionTextElementData } = {};

    static registerElement(example: BaseTextMergeElement) {
        TextElementRegistration.registrations[example.__type] = new ExpressionTextElementData(
            example,
            example.__type,
            example.name
        );
    }

    static getAllElements(): ExpressionTextElementData[] {
        let all = Object.values(TextElementRegistration.registrations).sort((a, b) => {
            return a.name.localeCompare(b.name);
        });
        all = all.sort((a, b) => {
            return a.example.ordinal < b.example.ordinal ? -1 : 1;
        });
        return all;
    }

    static getElement(type: string): ExpressionTextElementData | undefined {
        return TextElementRegistration.registrations[type];
    }
}

export function GetTextElementFromData(data: object): BaseTextMergeElement | undefined {
    if (!data) return;

    let typeName = Reflect.get(data, "__type");

    if (typeName) {
        let registeredControl = TextElementRegistration.getElement(typeName);

        let val = registeredControl?.create();

        // @ts-ignore
        let cc = val as BaseTextMergeElement;

        cc.setStorageData(data);

        return cc;
    }

    throw new Error(
        "Could not create expression: no type defined: " +
            typeName +
            " number registered: " +
            TextElementRegistration.registrations
    );
}

export function RegisterTextElement(element: BaseTextMergeElement) {
    TextElementRegistration.registerElement(element);

    if (!TextElementRegistration.getElement(element.__type)) throw new Error("registration failed");
}
